<script setup lang="ts">
import WidgetContainer from "@/components/EditView/widgets/WidgetContainer.vue";
import {WidgetProps} from "@/utils/presenters/interfaces.ts";
import FieldWidgetUtil from "@/utils/editView/widgets/FieldWidgetUtil.ts";

let props = defineProps<WidgetProps>();
const fieldId = props.field.id!;
let fieldUtil = new FieldWidgetUtil(props.presenter, props.fieldMetaData);

let text = fieldUtil.formattedValue();
</script>
<template>
  <WidgetContainer :field="field"
                   :entityType="presenter.entityType" :isSpanned="isSpanned" :isFieldDisabled="fieldUtil.isFieldDisabled(forceEnableField)"
                   :isFieldRequired="fieldUtil.isFieldRequired()" :doNotApplyThemeLayouts="doNotApplyThemeLayouts"
                   :isInsideComposite="isInsideComposite">
    <template v-slot:widget>
      <div v-html="text !== ''? text : '<br>'" class="tw-pl-2 tw-text-base tw-font-light tw-text-gray-800 dark:tw-text-white"></div>
    </template>
  </WidgetContainer>
</template>

<style>

</style>
